import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import EditorialMarquee from "@/components/landing/EditorialMarquee";
import Services from "@/components/landing/Services";
import Events from "@/components/landing/Events";
import Catering from "@/components/landing/Catering";
import Booking from "@/components/landing/Booking";
import Footer from "@/components/landing/Footer";

const Home = () => (
  <main className="relative">
    <div className="grain-overlay" aria-hidden="true" />
    <Navbar />
    <Hero />
    <EditorialMarquee />
    <Services />
    <Events />
    <Catering />
    <Booking />
    <Footer />
  </main>
);

function App() {
  return (
    <div className="App">
      <ReactLenis root options={{ lerp: 0.09, smoothWheel: true }}>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="bottom-right" toastOptions={{ style: { background: "#FDFBF7", border: "1px solid #E5D3B3" } }} />
      </ReactLenis>
    </div>
  );
}

export default App;
